import Users from 'src/components/Organization/pages/users';

export default Users;
